import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=f612d54a&scoped=true&"
import script from "./LiveDetail.vue?vue&type=script&lang=js&"
export * from "./LiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./LiveDetail.vue?vue&type=style&index=0&id=f612d54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f612d54a",
  null
  
)

export default component.exports